import { render } from "./users-search.template.html?vue&type=template&id=3df86cdb&scoped=true"
import script from "./UsersSearch.vue?vue&type=script&lang=ts"
export * from "./UsersSearch.vue?vue&type=script&lang=ts"

import "./UsersSearch.vue?vue&type=style&index=0&id=3df86cdb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3df86cdb"

export default script